import React from 'react'

function Ecommerce() {
  return (
    <div>Ecommerce</div>
  )
}

export default Ecommerce